import { render } from "./HorseEditEventsView.vue?vue&type=template&id=2d3fd540"
import script from "./HorseEditEventsView.vue?vue&type=script&lang=js"
export * from "./HorseEditEventsView.vue?vue&type=script&lang=js"

import "./HorseEditEventsView.vue?vue&type=style&index=0&id=2d3fd540&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__